import React, { Component } from 'react';
import './MakeModelFilter.css';
import { Select, Icon } from 'antd';
import { observer, inject } from 'mobx-react';

import { compact, groupBy, mapValues, isEmpty, throttle, flatten, uniq } from 'lodash';

@inject('carsStore', 'translationsStore', 'filterStore')
@observer
export default class MakeModelFilter extends Component {
  keyStorage = `carFilter_makesModels`;

  constructor(props) {
    super(props);

    let defaultState = {
      selectedMakes: [],
      selectedModels: [],
      selectedTypes: [],
      treeMakesModelsTypes: []
    };
    const { filterStore } = this.props;
    let { selectedMakes, selectedModels, selectedTypes } = filterStore.appliedFiltersParameters[this.keyStorage] || {};
    if (selectedMakes !== undefined && selectedModels !== undefined) {
      defaultState = { ...defaultState, selectedMakes, selectedModels, selectedTypes };
    }
    this.state = defaultState;
  }

  changeMakes = (selectedMakes = []) => {
    this.setState({ selectedMakes });
  };

  changeModels = (selectedModels = []) => {
    this.setState({ selectedModels: selectedModels.map(JSON.parse) });
  };

  changeTypes = (selectedTypes = []) => {
    this.setState({ selectedTypes: selectedTypes.map(JSON.parse) });
  };

  reset = () => {
    this.changeMakes();
    this.changeModels();
    this.changeTypes();
  };

  deselectMakes = make => {
    const newSelectedModels = this.state.selectedModels.filter(selectedModel => !selectedModel[make]);
    this.setState({ selectedModels: newSelectedModels.map(JSON.stringify) });

    this.applyfilter = true;
  };

  deselectModels = model => {
    const modelValue = Object.values(JSON.parse(model)).shift();
    const newSelectedTypes = this.state.selectedTypes.filter(type => !type[modelValue]);
    this.setState({ selectedTypes: newSelectedTypes.map(JSON.stringify) });

    this.applyfilter = true;
  };

  deselectTypes = () => {
    this.applyfilter = true;
  };

  resetMakeAndModels() {
    this.setState({
      selectedMakes: [],
      selectedModels: [],
      selectedTypes: [],
      uniqueModelsGroupedByMake: null,
      treeMakesModelsTypes: []
    });
    // this.applyfilter = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.resetMakeAndModels();
    }
    if (this.state.selectedMakes && prevState.selectedMakes !== this.state.selectedMakes) {
      this.buildFilterFunctions(
        this.state.selectedMakes.map(codiceMarca => ({ [codiceMarca]: '' })),
        this.state.selectedModels,
        this.state.selectedTypes,
        prevState.selectedMakes.length > this.state.selectedMakes.length
      );
    }
    if (this.state.selectedModels && prevState.selectedModels !== this.state.selectedModels) {
      this.buildFilterFunctions(
        this.state.selectedMakes.map(codiceMarca => ({ [codiceMarca]: '' })),
        this.state.selectedModels,
        this.state.selectedTypes,
        prevState.selectedModels.length > this.state.selectedModels.length
      );
    }
    if (this.state.selectedTypes && prevState.selectedTypes !== this.state.selectedTypes) {
      this.buildFilterFunctions(
        this.state.selectedMakes.map(codiceMarca => ({ [codiceMarca]: '' })),
        this.state.selectedModels,
        this.state.selectedTypes,
        prevState.selectedTypes.length > this.state.selectedTypes.length
      );
    }
  }

  buildFilterFunctions(makes = [], makesWithModel = [], modelWithTypes = []) {
    const { filterStore } = this.props;
    const modelsGroupedByMake = groupBy(makes.concat(makesWithModel), value => Object.keys(value)[0]);
    const uniqueModelsGroupedByMake = mapValues(modelsGroupedByMake, value => value.reduce((acc, value) => compact(acc.concat(Object.values(value)[0])), []));
    const flattenMakes = flatten(makes.map(make => Object.keys(make)));
    const flattenTypes = flatten(modelWithTypes.map(modelType => Object.values(modelType)));

    const treeMakesModelsTypes = this.props.carsStore.makesWithModels
      .map(dataMake => ({
        ...dataMake,
        models: dataMake.models
          .map(dataModel => ({ ...dataModel, types: dataModel.types.filter(dataType => flattenTypes.includes(dataType.codiceInfocarAM)) }))
          .filter(dataModel => dataModel.types.length > 0)
      }))
      .filter(dataMake => dataMake.models.length > 0);

    this.setState({ uniqueModelsGroupedByMake, treeMakesModelsTypes });

    filterStore.add(
      'carFilter_makesModels',
      car => {
        let models = uniqueModelsGroupedByMake[car.make.codiceMarca];
        // return isEmpty(uniqueModelsGroupedByMake) || (models && (models.length === 0 || models.includes(car.model.codiceModello)));
        return (
          (makes.length > 0 && (models && models.length === 0) && modelWithTypes.length === 0 && flattenMakes.includes(car.make.codiceMarca)) ||
          (modelWithTypes.length === 0 && models && (models.length === 0 || models.includes(car.model.codiceModello))) ||
          (modelWithTypes.length > 0 && flattenTypes.includes(car.type.codiceInfocarAM))
        );
      },
      undefined,
      {
        selectedMakes: this.state.selectedMakes,
        selectedModels: this.state.selectedModels,
        selectedTypes: this.state.selectedTypes
      }
    );

    if (makes.length === 0 && makesWithModel.length === 0 && modelWithTypes.length === 0) {
      filterStore.remove('carFilter_makesModels');
      filterStore.apply();
    }

    if (this.applyfilter && filterStore.appliedFiltersContains(/carFilter_makesModels/)) {
      filterStore.apply();
      // this.applyfilter = false;
    } else if (this.applyfilter && filterStore.appliedFiltersContains(/carFilter_/) && !filterStore.appliedFiltersContains(/carFilter_makesModels/)) {
      filterStore.apply();
      // this.applyfilter = false;
    }
    this.applyfilter = false;
  }

  apply = () => throttle(this.props.filterStore.apply.bind(this.props.filterStore), 400)();

  selectionDescription = () => {
    const justMakesModels = Object.keys(this.state.uniqueModelsGroupedByMake).map(codiceMarca => {
      let descrizioneMarca = (this.props.carsStore.makesDescription.find(make => make.codiceMarca === codiceMarca) || '').descrizione;
      let descrizioneModelli = this.state.uniqueModelsGroupedByMake[codiceMarca]
        .map(codiceModello => this.props.carsStore.modelsDescription.find(model => model.codiceModello === codiceModello).descrizione)
        .join(', ');
      return `${descrizioneMarca} ${descrizioneModelli ? `[${descrizioneModelli}]` : ''}`;
    });
    let justTypes = [];
    this.state.treeMakesModelsTypes.map(make => {
      make.models.map(model => {
        model.types.map(type => {
          justTypes.push(`${make.descrizione} → ${model.descrizione} → ${type.descrizione}`);
        });
      });
    });
    return justMakesModels.concat(justTypes).join(', ');
  };

  render() {
    const { translationsStore, carsStore, status } = this.props;
    // const { selectedMakes, selectedModels, selectedTypes } = this.state;
    let { selectedMakes, selectedModels, selectedTypes } = this.state;
    selectedModels = selectedModels.map(model => JSON.stringify(model));
    selectedTypes = selectedTypes.map(type => JSON.stringify(type));

    return (
      <div className="MakeModelFilter" id="MakeModelFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.makeModelType')}
          <span>
            {(!isEmpty(this.state.uniqueModelsGroupedByMake) || !isEmpty(this.state.treeMakesModelsTypes)) && status != false && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className="selected" title={this.selectionDescription()}>
                  {this.selectionDescription()}
                </div>
                <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.reset} />
              </div>
            )}
          </span>
        </div>

        <div className="selectContainer">
          <Select
            maxTagCount={4}
            onDeselect={this.deselectMakes}
            mode="multiple"
            value={selectedMakes}
            getPopupContainer={() => document.getElementById('MakeModelFilter')}
            onChange={this.changeMakes}
            optionFilterProp="description"
          >
            {carsStore.makesWithModels.map(make => (
              <Select.Option key={make.codiceMarca} value={make.codiceMarca} description={make.descrizione}>
                {make.descrizione}
              </Select.Option>
            ))}
          </Select>
          <Select
            maxTagCount={2}
            onDeselect={this.deselectModels}
            value={selectedModels}
            getPopupContainer={() => document.getElementById('MakeModelFilter')}
            disabled={carsStore.models.length === 0}
            onChange={this.changeModels}
            mode="multiple"
            optionFilterProp="description"
          >
            {carsStore.makesWithModels
              .filter(make => {
                if (selectedMakes && selectedMakes.length > 0) {
                  return selectedMakes.includes(make.codiceMarca);
                }
                return true;
              })
              .map(make => (
                <Select.OptGroup key={make.codiceMarca} label={make.descrizione}>
                  {make.models.map(model => (
                    <Select.Option key={model.codiceModello} value={`{"${make.codiceMarca}":"${model.codiceModello}"}`} description={`${make.descrizione} ${model.descrizione}`}>
                      {make.descrizione} {model.descrizione}
                    </Select.Option>
                  ))}
                </Select.OptGroup>
              ))}
          </Select>
          <Select
            maxTagCount={1}
            onDeselect={this.deselectTypes}
            value={selectedTypes}
            getPopupContainer={() => document.getElementById('MakeModelFilter')}
            disabled={carsStore.types.length === 0}
            onChange={this.changeTypes}
            mode="multiple"
            optionFilterProp="description"
          >
            {carsStore.makesWithModels
              .map(make => {
                if (selectedModels && selectedModels.length > 0) {
                  const selectedModelsAsObj = selectedModels.map(selected => JSON.parse(selected));
                  const selectedModelsMakeCodice = uniq(flatten(selectedModelsAsObj.map(selected => Object.keys(selected))));
                  const selectedModelsCodice = flatten(selectedModelsAsObj.map(selected => Object.values(selected)));
                  const pickedMake = { ...make, models: make.models.filter(model => selectedModelsCodice.includes(model.codiceModello)) };
                  return selectedModelsMakeCodice.includes(make.codiceMarca) ? pickedMake : selectedMakes.includes(make.codiceMarca) ? make : undefined;
                } else {
                  if (selectedMakes && selectedMakes.length > 0) {
                    return selectedMakes.includes(make.codiceMarca) ? make : undefined;
                  }
                  return make;
                }
              })
              .filter(make => make !== undefined)
              .map(make => {
                return make.models.map(model => (
                  <Select.OptGroup key={model.codiceModello} label={model.descrizione}>
                    {model.types.map(type => (
                      <Select.Option
                        key={type.codiceInfocarAM}
                        value={`{"${model.codiceModello}":"${type.codiceInfocarAM}"}`}
                        description={`${model.descrizione} ${type.descrizione}`}
                      >
                        {model.descrizione} {type.descrizione}
                      </Select.Option>
                    ))}
                  </Select.OptGroup>
                ));
              })}
          </Select>
        </div>
      </div>
    );
  }
}
